__turbopack_context__.v({
  "className": "nunito_d587f023-module__RM8P7a__className",
  "variable": "nunito_d587f023-module__RM8P7a__variable",
});
